export enum ApplicationReportColumns {
  DateSubmitted = 'date_submitted',
  StudentLegalName = 'student_legal_name',
  StudentGradeLevel = 'student_grade_level',
  AddressSchoolDistrict = 'address_school_district',
  SpecialEducation = 'meta_special_education',
  ParentLegalName = 'parent_legal_name',
  ParentEmail = 'parent_email',
}
